// 🧠 SERVIÇO DE EMBEDDINGS — apenas helpers de texto pré-busca
// Sistema: HEPATO TX RONDÔNIA
//
// Após B95 Commit 7 (AI_65), as funções de geração de embeddings (Voyage)
// e conversão de chunks para vetores (Pinecone) saíram deste arquivo.
// Toda comunicação com Voyage/Pinecone acontece agora no backend.
//
// Este arquivo mantém apenas enrichQuery — função pura de texto, sem rede.

export function enrichQuery(query: string): string {
  const expansions: Record<string, string[]> = {
    rejeição: ["rejection", "acute cellular rejection", "banff"],
    tacrolimus: ["calcineurin inhibitor", "immunosuppression", "FK506"],
    trombose: [
      "thrombosis",
      "hepatic artery thrombosis",
      "portal vein thrombosis",
    ],
    biliar: ["biliary", "bile duct", "anastomotic stricture"],
    cirrose: ["cirrhosis", "liver fibrosis", "portal hypertension"],
    ascite: ["ascites", "fluid retention", "paracentesis"],
    encefalopatia: ["encephalopathy", "hepatic encephalopathy", "ammonia"],
    hepatocarcinoma: ["hepatocellular carcinoma", "HCC", "liver cancer"],
    // B316 (AI_142): expande a query PT de situação especial p/ casar também os
    // guidelines internacionais de exceção de MELD.
    "situação especial": ["MELD exception points", "waitlist special situation"],
    refratária: ["refractory", "diuretic-resistant"],
  };

  let enrichedQuery = query;

  for (const [ptTerm, enTerms] of Object.entries(expansions)) {
    if (query.toLowerCase().includes(ptTerm)) {
      enrichedQuery += ` ${enTerms.slice(0, 2).join(" ")}`;
    }
  }

  return enrichedQuery;
}
